import AsyncStorage from '@react-native-async-storage/async-storage';
import config from '../config';
import { bundledPresentation, bundledBaseline } from './bundledPresentation';
import { dropRetiredControls, isAppearance } from './appearance';
import { validateAppScreens } from '../screenBuilder/validation';
import type { PresentationSnapshot } from './PresentationContext';

// Public UI configuration only, scoped to the API deployment. Never cache user/account data.
export const PRESENTATION_CACHE_KEY = `app-presentation:v1:${config.apiGateway.endpoint}:${bundledBaseline.revision}`;
export const defaultPresentation = (): PresentationSnapshot => bundledPresentation();
export function readPresentation(value: unknown): PresentationSnapshot | null {
  if (!value || typeof value !== 'object' || !('version' in value) || value.version !== 1 || !('appearance' in value) || !('screens' in value)) return null;
  const appearance = dropRetiredControls(value.appearance);
  if (!isAppearance(appearance) || validateAppScreens(value.screens).errors.length) return null;
  return { version: 1, appearance, screens: value.screens as PresentationSnapshot['screens'] };
}
export async function readPresentationCache(): Promise<PresentationSnapshot | null> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    const raw = await Promise.race([AsyncStorage.getItem(PRESENTATION_CACHE_KEY), new Promise<null>(resolve => { timer = setTimeout(() => resolve(null), 750); })]);
    return raw ? readPresentation(JSON.parse(raw)) : null;
  } catch { return null; }
  finally { if (timer) clearTimeout(timer); }
}
export async function cachePresentation(value: PresentationSnapshot): Promise<void> {
  if (!readPresentation(value)) return;
  try { await AsyncStorage.setItem(PRESENTATION_CACHE_KEY, JSON.stringify(value)); }
  catch { /* Storage failure does not prevent using the validated session snapshot. */ }
}
